//dependencies
import React from "react";

import { toast } from "@performyard/py-components";

import { AdminTitle } from "../../../../../../../components/Admin";
import Spacer from "../../../../../../../components/Spacer";
import Text from "../../../../../../../components/Text";

//hooks
import useNavigate from "../../../../../../../hooks/useNavigate";

//services
import { updateCohort } from "../../../../../../../api/services";

//components
import DynamicEmployeesQueryBuilder from "../../../../Components/DynamicEmployeesQueryBuilder";
import { DynamicCohortQuery } from "../../../../Components/DynamicEmployeesQueryBuilder/DynamicEmployeesUtils";
// css
import css from "./DynamicEmployees.module.scss";

declare interface DynamicEmployeesEditProps {
	backUrl: string;
	cohort: {
		_id: string;
		name: string;
		query?: DynamicCohortQuery;
	};
}

const DynamicEmployeesEdit = ({ backUrl, cohort }: DynamicEmployeesEditProps) => {
	const navigate = useNavigate();

	return (
		<>
			<AdminTitle includeSpacer={false}>Employee Cohorts</AdminTitle>
			<Spacer height={4} />
			<div className={css.header}>
				<Text className={css.name} size="paragraph-1" weight="semi-bold" color="neutral-9">
					Edit Conditions of {cohort.name}
				</Text>
			</div>
			<Spacer height={2} />
			<DynamicEmployeesQueryBuilder
				isEdit
				goBack={() => navigate(backUrl)}
				onSave={async (updatedCohortQuery: DynamicCohortQuery) => {
					try {
						await updateCohort(cohort._id, {
							query: updatedCohortQuery,
						});
						toast.success(`Successfully updated cohort`);
						navigate(`/administration/engagement/cohorts`);
					} catch (e) {
						toast.error("Unable to add employees to cohort.");
					}
				}}
				existingDynamicEmployeesQuery={cohort.query}
			/>
		</>
	);
};

export default DynamicEmployeesEdit;
